import { useQueryClient, useMutation } from 'react-query';
import { useAxiosInstance } from '../common';
import { FileNode } from '../../types/DataDelivery';
import { findFileNodeRecursively, mergeFileNodes } from '../../common/fileNodeHelper';

const useGenerateFileNode = () => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (path: string) => {
      const response = await axios.post<FileNode>("filenode/file_structure", null, {
        params: {
          path,
        },
      });
      return response.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['rootStructure'], { refetchInactive: true });
        /*const rootFileNode: FileNode = queryClient.getQueryData(['rootStructure', data.organizationId]);
        if (rootFileNode) {
          const fileNodeToUpdate: FileNode = findFileNodeRecursively(rootFileNode, data.id);
          if (fileNodeToUpdate) {
            const mergedFileNode = mergeFileNodes(fileNodeToUpdate, data);
            Object.assign(fileNodeToUpdate, mergedFileNode);
            queryClient.setQueryData(['rootStructure', data.organizationId], rootFileNode);
          }
        }*/
        if (queryClient.getQueryData(['fileNodeStructure', data.rootId])) {
          const rootFileNode2: FileNode = JSON.parse(
            JSON.stringify(queryClient.getQueryData(['fileNodeStructure', data.rootId]))
          );
          if (rootFileNode2) {
            const fileNodeToUpdate: FileNode = findFileNodeRecursively(rootFileNode2, data.id);
            if (fileNodeToUpdate) {
              const mergedFileNode = mergeFileNodes(fileNodeToUpdate, data);
              Object.assign(fileNodeToUpdate, mergedFileNode);
              queryClient.setQueryData(['fileNodeStructure', data.rootId], rootFileNode2);
            }
          }
        }
      },
    }
  );
};

export default useGenerateFileNode;
